import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isLocalDevelopment } from '../utils/config';

const HomePage: React.FC = () => {
  const { t } = useTranslation();
  const isLocal = isLocalDevelopment();

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      textAlign: 'center',
      padding: '2rem'
    }}>
      <div>
        <h1 style={{ fontSize: '3rem', marginBottom: '1rem' }}>{t('title')}</h1>
        <p style={{ fontSize: '1.2rem', opacity: 0.9, marginBottom: '2rem' }}>
          This application requires a valid card view request token in the URL.
        </p>
        <p style={{ fontSize: '1rem', opacity: 0.7, marginBottom: '2rem' }}>
          Example: /your-card-request-token?language=en
        </p>
        
        {isLocal && (
          <div style={{ 
            background: 'rgba(255, 255, 255, 0.1)', 
            padding: '1.5rem', 
            borderRadius: '12px',
            marginTop: '2rem',
            backdropFilter: 'blur(10px)'
          }}>
            <h3 style={{ margin: '0 0 1rem 0', color: '#ffd700' }}>🧪 Development Mode</h3>
            <p style={{ fontSize: '0.9rem', opacity: 0.8, marginBottom: '1rem' }}>
              Test the application with a sample CVRT token:
            </p>
            <Link 
              to="/01234567890123456789012345678901?language=en"
              style={{
                display: 'inline-block',
                background: 'rgba(255, 255, 255, 0.2)',
                color: 'white',
                textDecoration: 'none',
                padding: '0.75rem 1.5rem',
                borderRadius: '6px',
                transition: 'all 0.2s ease',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                fontFamily: 'Courier New, monospace',
                fontSize: '0.9rem'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.3)';
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              Test with Sample Token
            </Link>
            <p style={{ fontSize: '0.8rem', opacity: 0.6, marginTop: '1rem' }}>
              Token: 01234567890123456789012345678901
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default HomePage;